<script setup>
import { AisRangeInput } from 'vue-instantsearch/vue3/es'

const formatMinValue = (minValue, minRange) => {
  return minValue !== null && minValue !== minRange ? minValue : '';
}
const formatMaxValue = (maxValue, maxRange) => {
  return maxValue !== null && maxValue !== maxRange ? maxValue : '';
}
</script>

<template>
<AisRangeInput v-bind="$attrs">
  <template
    v-slot="{
      currentRefinement,
      range,
      canRefine,
      refine,
      sendEvent,
    }"
  >
    <div class="flex w-full space-x-2 items-center">
      <input
        type="number"
        :min="range.min"
        :max="range.max"
        :placeholder="range.min"
        :disabled="!canRefine"
        :value="formatMinValue(currentRefinement.min, range.min)"
        @input="refine({
          min: $event.currentTarget.value,
          max: formatMaxValue(currentRefinement.max, range.max),
        })"
        class="rounded-md border bg-white shadow-sm w-full block w-full max-w-lg rounded-l-md p-2 focus:border-primary-300 focus:ring-primary-200/50 sm:text-sm"
        aria-describedby="price-currency"
      />
      <div>{{ __('to') }}</div>
      <input
        type="number"
        :min="range.min"
        :max="range.max"
        :placeholder="range.max"
        :disabled="!canRefine"
        :value="formatMaxValue(currentRefinement.max,range.max)"
        @input="refine({
          min: formatMinValue(currentRefinement.min, range.min),
          max: $event.currentTarget.value,
        })"
        class="rounded-md border bg-white shadow-sm w-full block w-full max-w-lg rounded-l-md p-2 focus:border-primary-300 focus:ring-primary-200/50 sm:text-sm"
        aria-describedby="price-currency"
      />
    </div>
  </template>
</AisRangeInput>
</template>
